import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { User } from 'services/types/user';

import type { Action } from './base';

const initialState: User = {
  id: 0,
  email: '',
  accessToken: '',
  isAdmin: false,
  businessUnitIds: [],
  filterConversationsByDefault: true,
  isTestUser: false,
  createdAt: '',
  updatedAt: '',
  name: null,
  phone: null,
  canAssignClient: false,
  isAssignable: false,
  role: 'seller',
  companyId: 0,
};

interface UserAction extends Action {
  payload: User;
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signInUser(state: User, action: UserAction) {
      return {
        ...state,
        ...action.payload,
      };
    },
    signUpUser(state: User, action: UserAction) {
      return {
        ...state,
        ...action.payload,
      };
    },
    signOutUser() {
      return {
        ...initialState,
      };
    },
    setAccessToken(state: User, action: PayloadAction<string>) {
      return { ...state, accessToken: action.payload };
    },
    setUserName: (state, action: PayloadAction<string>) => {
      return { ...state, name: action.payload };
    },
  },
});

export const { signInUser, signUpUser, signOutUser, setUserName, setAccessToken } = userSlice.actions;
export default userSlice.reducer;
